import { useEffect, useState } from "react";
import Table from "../../Table";
import {
  getMarketDataMapping,
  getMarketDataSubscription,
} from "../../../utils/apis/accountsApi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { returnErrors } from "../../../utils/store/reducers/Error";
import {
  marketSubscribe,
  marketUnSubscribe,
} from "../../../utils/apis/payment";
import { returnMessages } from "../../../utils/store/reducers/Message";
import { setLastPayment } from "../../../utils/store/reducers/accountMetricsSlice";
import ConfirmationModal from "../ConfirmationModal";
import Tabination from "../../../reusableComponents/Tabs";
import LoaderOverlay from "../../../reusableComponents/LoaderOverlay/Index";
import RePaymentModal from "../../../reusableComponents/RePaymentModal/RePaymentModal";

const MarketDataSubscription = () => {
  const [marketSubscription, setMarketSubscription] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const { platForm_list } = useSelector((state) => state.accountMetrics.plans);
  const { idToken } = useSelector((state) => state.auth);
  const [params, setParams] = useState(null);
  const [brokers, setBrokers] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openRepay, setOpenRepay] = useState(false);
  const [payload, setPayload] = useState({
    payment_method: "nuvei",
    platform: null,
  });
  const [isLoadings, setIsLoadings] = useState(false);
console.log(activeTab,"activeTabactiveTab");
  const dispatch = useDispatch();
  const fetchMarketSubscription = async () => {
    setIsLoading(true);
    try {
      // Validate required parameters
      const selectedPlatform = params || platForm_list?.[0]?.value;
      if (!idToken || !selectedPlatform) {
        throw new Error(
          "Missing required parameters: idToken or selectedPlatform"
        );
      }

      // Fetch market data and mapping concurrently
      const [response, mappingResponse] = await Promise.all([
        getMarketDataSubscription(idToken, selectedPlatform),
        getMarketDataMapping(idToken, selectedPlatform),
      ]);

      // Log response for debugging
      console.log("Market data response:", response);

      // Handle platform-specific logic
      if (selectedPlatform) {
        // If no data in response.detail, use mappingResponse
        if (!response?.detail?.length) {
          setMarketSubscription(mappingResponse || []);
          return;
        }

        // Filter EUREX and CME items
        const eurexItems =
          response?.detail?.filter((item) =>
            item?.notation?.includes("EUREX_DOM")
          ) || [];
        const cmeItems =
          response?.detail?.filter((item) =>
            item?.notation?.includes("CMEGROUP_DOM")
          ) || [];
        const eurexMapping =
          mappingResponse?.filter((item) =>
            item?.notation?.includes("EUREX_DOM")
          ) || [];
        const cmeTobMapping =
          mappingResponse?.filter((item) =>
            item?.notation?.includes("CMEGROUP_TOB")
          ) || [];

        // Set subscription data with fallback to mapping if no items found
        setMarketSubscription([
          ...(eurexItems.length > 0 ? eurexItems : eurexMapping),
          ...(cmeItems.length > 0 ? cmeItems : cmeTobMapping),
        ]);
        return;
      }

      // Default case for other platforms
      const filteredData =
        response?.detail?.filter((item) => item?.notation?.includes("DOB")) ||
        [];

      setMarketSubscription(
        filteredData.length > 0
          ? filteredData
          : mappingResponse?.filter((item) =>
              item?.notation?.includes("TOB")
            ) || []
      );
    } catch (error) {
      console.error("Error fetching market subscription:", error);
      dispatch(
        returnErrors(
          error.response?.data?.detail || "Failed to fetch market subscription",
          error.response?.status || 400
        )
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (platForm_list?.length > 0) {
      const initialBrokers = platForm_list.map((item) => ({
        name: item.label,
        path: item.value,
      }));
      setBrokers(initialBrokers);
      setParams(initialBrokers[0]?.path); // Set the default platform
    }
  }, [platForm_list]);

  useEffect(() => {
    if (brokers.length > 0) {
      const selectedPlatform = brokers[activeTab]?.path;
      setParams(selectedPlatform);
    }
  }, [activeTab, brokers]);

  useEffect(() => {
    if (params) {
      fetchMarketSubscription();
    }
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps



  const handleMarketSub = async () => {
    setIsLoadings(true);
    try {
      const updatedPayload = { ...payload, platform: params };
      const response = await marketSubscribe(idToken, updatedPayload);
      if (response.status === 200) {
        dispatch(setLastPayment(response?.data?.data));
        window.location.replace(response?.data.url);
      } else {
        dispatch(returnErrors(response.response?.data?.detail, 400));
      }
    } catch (error) {
      dispatch(returnErrors(error.response?.data?.detail, 400));
    } finally {
      setIsLoadings(false);
    }
  };

  const handleMarketUnSub = async (value) => {
    try {
      setIsLoadings(true);
      const response = await marketUnSubscribe(idToken, isModalOpen);
      if (response.status === 200) {
        dispatch(returnMessages(response.data.detail, 200));
        fetchMarketSubscription();
      } else {
        dispatch(returnErrors(response.response?.data?.detail, 400));
      }
    } catch (error) {
      dispatch(returnErrors(error.response?.data?.detail, 400));
    } finally {
      setIsLoadings(false);
      setIsModalOpen(false);
    }
  };

  const columns = [
    {
      Header: "Level",
      accessor: "level",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value || "1"}</p>
        </div>
      ),
    },
    {
      Header: "Notation",
      accessor: "notation",
      Cell: ({ value, row }) => (
        <div className="col-wrapper">
          <p>
            {row?.values?.level === "1" && value === "EUREX_DOM"
              ? "N/A"
              : value}
          </p>
        </div>
      ),
    },
    {
      Header: "Payment Id",
      accessor: "current_period_payment",
      Cell: ({ value, row }) => {
        console.log("row", row);

        return (
          <div className="col-wrapper">
            <p>
              {row?.values?.current_period_payment
                ? row?.values?.current_period_payment
                : "Free"}
            </p>
          </div>
        );
      },
    },
    // {
    //   Header: "Created Date",
    //   accessor: "created_at",
    //   Cell: ({ value }) => (
    //     <div className="col-wrapper">
    //       <p>{value ? moment(value).format("DD-MM-YYYY") : "N/A"}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "Start Date",
      accessor: "start_date",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value ? moment(value).format("DD-MM-YYYY") : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Current period Start",
      accessor: "current_period_start",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value ? moment(value).format("DD-MM-YYYY") : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Current period End",
      accessor: "current_period_end",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value ? moment(value).format("DD-MM-YYYY") : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Subscription Status",
      accessor: "is_sub_active",
      Cell: ({ value, row }) => {
        return (
          <button
            className={`comp_status ${
              value ? "green_status" : "red_status"
            }`}
            style={{ textTransform: "capitalize" }}
          >
            {value ? "Active" : "Inactive"}
          </button>
        );
      },
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ({ value, row }) => {
        return (
          <div>
            <ConfirmationModal
              open={isModalOpen}
              handleConfirm={() => handleMarketUnSub(value)}
              handleClose={() => setIsModalOpen(false)}
              message={
                params === 2
                  ? "Unsubscribe to market data level 2/EURX will bring you to market data level 1"
                  : "Are you sure you want to unsubscribe?"
              }
              loading={isLoadings}
            />
            <RePaymentModal
              open={openRepay}
              setOpen={setOpenRepay}
              handleSubmit={handleMarketSub}
              isLoading={isLoadings}
              setPayload={setPayload}
              payload={payload}
              size=""
              initialAmount={payload?.notation === "EUREX_DOM" ? 26 : 41}
              heading="Market Data Subscription"
              isCoupon={false}
            />
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {value && row.original.current_period_payment ? (
                <button
                  className="contract_payment_btn"
                  onClick={() => setIsModalOpen(row.original.id)}
                >
                  Unsubscribe
                </button>
              ) : (
                <button
                  className="contract_payment_btn"
                  onClick={() => {
                    setOpenRepay(true);
                    setPayload((pre) => ({
                      ...pre,
                      notation:
                        row.original.notation === "CMEGROUP_TOB"
                          ? "CMEGROUP_DOM"
                          : row.original.notation,
                    }));
                  }}
                >
                  {`Upgrade to ${
                    row.original.notation === "CMEGROUP_TOB"
                      ? "CMEGROUP_DOM"
                      : row.original.notation
                  }`}
                </button>
              )}
            </div>
          </div>
        );
      },
    },
  ];

  const tableData = marketSubscription || [];

  console.log(marketSubscription, "marketSubscriptionmarketSubscription");
  return (
    <div className="account-receipts">
      {isLoading && <LoaderOverlay />}
      <div className="ar-header">
        <Tabination
          variant={1}
          tabItems={brokers}
          showTabs={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
      <div className="ar-table">
        <Table columns={columns} data={tableData} variant={2} />
      </div>
    </div>
  );
};

export default MarketDataSubscription;
